<template>
  <div>

    <div class="panel">

      <b-table
        :data="history"
        :loading="isLoadingTable"

        paginated
        backend-pagination
        :per-page="perPage"
        :total="total"
        @page-change="onPageChange"

        backend-sorting
        :default-sort="orderField"
        :default-sort-direction="orderDir"
        @sort="onSort"

        class="w-full text-sm"
        striped
        bordered
        icon-pack="fas"
      >

        <template>

          <b-table-column field="date" :label="$t('date')" sortable v-slot="props">
            {{ parseDate(props.row.created_at) }}
          </b-table-column>

          <b-table-column field="name" :label="$t('name')" sortable v-slot="props">
            {{ props.row.document.original_filename }}
          </b-table-column>

          <b-table-column field="description" :label="$t('description')" sortable v-slot="props">
            {{ props.row.description }}
          </b-table-column>


          <b-table-column :label="$t('actions')" field="actions" centered width="100" v-slot="props">
            <div class="w-full h-full flex items-center justify-around">
              <b-tooltip
                :label="$t('download')" position="is-left">
                <div @click="downloadButtonClicked(props.row.document.id)"
                     class="cursor-pointer flex text-blue text-lg">
                  <b-icon pack="fas" icon="file-download"/>
                </div>
              </b-tooltip>
            </div>
          </b-table-column>

        </template>

        <template #empty>
          <div class="has-text-centered">{{ $t('no_results') }}</div>
        </template>
      </b-table>

    </div>

  </div>
</template>

<script>
  import axios from 'axios'

  export default {

    props: {
      projectId: { type: Number, required: true },
      emitParentList: { type: Boolean, default: false }
    },

    data: function() {
      return {
        isLoadingTable: true,
        history: [],
        perPage: 20,
        orderField: 'name',
        orderDir: 'asc',
        page: 1,
        total: 0,
      }
    },

    created() {
      this.getHistory()
    },

    methods: {
      async getHistory() {
        this.isLoadingTable = true
        this.history = []

        let params = {
          'project_id': this.projectId,
          'type': 'detailed_report',
          'order_field': this.orderField,
          'order_dir': this.orderDir,
          'page': this.page,
          'per_page': this.perPage,
        }

        const {data} = await axios.get(`/api/v2/project/${this.projectId}/document-reports`, {params: params})
        if (data && data.success) {
          this.history = data.documents
          this.total = data.documents.length
        } else {
          this.$notify.error(data.msg);
        }
        this.isLoadingTable = false
      },

      parseDate(dateString) {
        let date = new Date(dateString)
        let day = String(date.getDate()).padStart(2, '0')
        let month = String(date.getMonth() + 1).padStart(2, '0')
        let year = date.getFullYear()
        return `${day}/${month}/${year}`
      },

      onSort(field, order) {
        this.projectId = this.projectId
        this.orderField = field
        this.orderDir = order
        this.getHistory()
      },

      onPageChange(page) {
        this.page = page
        this.getHistory()
      },

      async downloadButtonClicked(document_id) {
        this.$notify.success("starting_download_document");
        let url = "/api/v2/document/" + document_id;

        const {data} = await axios.get(url);

        if (data) {
          window.open(data.data);
        } else {
          this.$notify.error("error_download_document");
        }
      },

    },

  };
</script>
